// Zakázky: typované funkce nad api() podle smlouvy v docs/SPEC.md část 5.
import type {
  AiNoteResponse,
  ApiList,
  ChangeStageInput,
  FirstResponseInput,
  CreateEntityNoteInput,
  CreateJobInput,
  JobDetail,
  JobStage,
  JobSummary,
  LostJobInput,
  UpdateJobInput,
} from '@wac-buddy/shared'
import { api } from './client'
import { buildQuery } from './query'

export interface ListJobsParams {
  q?: string
  stage?: JobStage
  clientId?: string
  /** true = jen ztracené, false = jen aktivní. */
  lost?: boolean
  cursor?: string | null
  limit?: number
}

export function listJobs(params: ListJobsParams = {}): Promise<ApiList<JobSummary>> {
  return api(
    `/jobs${buildQuery({
      q: params.q?.trim(),
      stage: params.stage,
      clientId: params.clientId,
      lost: params.lost,
      cursor: params.cursor,
      limit: params.limit,
    })}`,
  )
}

export function createJob(input: CreateJobInput): Promise<JobDetail> {
  return api('/jobs', { method: 'POST', body: JSON.stringify(input) })
}

export function getJob(id: string): Promise<JobDetail> {
  return api(`/jobs/${encodeURIComponent(id)}`)
}

export function updateJob(id: string, input: UpdateJobInput): Promise<JobDetail> {
  return api(`/jobs/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(input) })
}

export function deleteJob(id: string): Promise<void> {
  return api(`/jobs/${encodeURIComponent(id)}`, { method: 'DELETE' })
}

export function changeJobStage(id: string, input: ChangeStageInput): Promise<JobDetail> {
  return api(`/jobs/${encodeURIComponent(id)}/stage`, {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

export function markJobLost(id: string, input: LostJobInput): Promise<JobDetail> {
  return api(`/jobs/${encodeURIComponent(id)}/lost`, {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

export function restoreJob(id: string): Promise<JobDetail> {
  return api(`/jobs/${encodeURIComponent(id)}/restore`, { method: 'POST' })
}

/** První reakce na poptávku (zavolat, navrhnout termín, odmítnout). Odmítnutí zakázku ztratí. */
export function postFirstResponse(id: string, input: FirstResponseInput): Promise<JobDetail> {
  return api(`/jobs/${encodeURIComponent(id)}/first-response`, {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

/** Poznámka k zakázce: uloží se do časové osy zakázky i klienta a Buddy v ní hledá sliby a úkoly. */
export function postJobNote(id: string, input: CreateEntityNoteInput): Promise<AiNoteResponse> {
  return api(`/jobs/${encodeURIComponent(id)}/notes`, {
    method: 'POST',
    body: JSON.stringify(input),
  })
}
